module.exports = __webpack_public_path__ + "static/media/MHRP25N0002.12990046.svg";